import { useQuery } from '@tanstack/react-query';
import { createServerFn } from '@tanstack/react-start';
import { useMemo } from 'react';
import { API } from '~/api';

import { urls } from '@repo/app-constants';
import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { PractitionerKit } from '@repo/types';

import testPackageGutPRO from '~/assets/images/practitioners/test-gut-PRO.jpg';
import testPackageGut from '~/assets/images/practitioners/test-gut.jpg';
import testPackageVaginal from '~/assets/images/practitioners/test-vag.jpg';

export const DISPLAY_NAMES: { [key: string]: string } = {
  GUT_HEALTH_TEST_PRACTITIONER: 'Gut Health Test',
  VAGINAL_HEALTH_TEST_PRACTITIONER: 'Vaginal Health Test',
  TINY_PRO_GUT_HEALTH_TEST: 'PRO Gut Health Test',
};

export const KIT_IMAGES: { [key: string]: string } = {
  GUT_HEALTH_TEST_PRACTITIONER: testPackageGut,
  VAGINAL_HEALTH_TEST_PRACTITIONER: testPackageVaginal,
  TINY_PRO_GUT_HEALTH_TEST: testPackageGutPRO,
};

export const getPractitionerKitsForPatient = createServerFn({
  method: 'GET',
  response: 'data',
}).handler(async () => {
  const response = await API.get(
    `${urls.apiBasePath}/practitioners/patient-invoices/kits`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ORDERING,
        domain: DOMAINS.KITS,
        importance: IMPORTANCE.HIGH,
      },
      context: {},
    },
  );
  return response?.result;
});

const usePractitionerKitsForPatient = () => {
  const practitionerKitsForPatientQuery = useQuery<PractitionerKit[]>({
    queryKey: [`practitionerKitsForPatient`],
    queryFn: () => getPractitionerKitsForPatient() || [],
  });

  return {
    ...practitionerKitsForPatientQuery,
    data: useMemo(
      () =>
        practitionerKitsForPatientQuery.data?.map(kit => {
          const display_title = `${
            DISPLAY_NAMES[kit.lookup_code]
              ? DISPLAY_NAMES[kit.lookup_code]
              : kit.name
          } - $${kit.price}`;
          return {
            ...kit,
            display_title,
            display_name: DISPLAY_NAMES[kit.lookup_code],
            store_link: urls.STORE_LINKS[kit.lookup_code],
            info_link: urls.INFO_LINKS[kit.lookup_code],
            // Keep a single source of truth for price
            price: kit.price,
            is_pro: kit.lookup_code.includes('PRO'),
            is_gut: kit.lookup_code.includes('GUT'),
            is_vaginal: kit.lookup_code.includes('VAGINAL'),
          };
        }),
      [practitionerKitsForPatientQuery.data],
    ),
  };
};

export default usePractitionerKitsForPatient;
